<template>
  <div class="notes matter-engagement-tab">
    <div class="notes-wrapper">
      <NotesList
        v-if="currContact"
        :refreshId="refreshId"
        @action="handleActions"
        :menu-on-hover="!isMobile"
        :display-author="isMultipleStaffs" />
    </div>
    <FabBtn
      :bgColor="brandBgColor"
      :textColor="brandTxtColor"
      custom-class="bottom-right"
      @click="handleBtnClick()"
      icon="icon-plus-s"
      :tooltip-text="isMobile ? '' : $t('client.matters.matter_page.fabs.notes')"/>
  </div>
</template>

<script>
import NotesList from '@/modules/matters/components/NotesList/NotesList'
import NoteCard from '@/modules/matters/components/NoteCard/NoteCard'
import {FabBtn} from "@/modules/common/components"
import {mapGetters} from "vuex";


export default {
  name: "Notes",
  components: {
    NotesList,
    NoteCard,
    FabBtn,
  },
  props: {
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      refreshId: 0,
    }
  },
  created() {
    this.$frontageApi.listen('fetch-notes', this.onRefreshEvent.bind(this))
    this.$frontageApi.listen('remove-note', this.onRemoveEvent)
    this.reset()
  },
  computed: {
    ...mapGetters('mattersModule', ['matter', 'currContact']),
    isMultipleStaffs() {
      return this.$store.getters['accountModule/isMultipleStaffs']
    },
    brandBgColor() {
      return this.$store.getters['brandModule/secondaryColor']
    },
    brandTxtColor() {
      return this.$store.getters['brandModule/textColor']
    },
    perPage() {
      return this.$store.getters['mattersModule/perPage']
    }
  },
  methods: {
    onRefreshEvent({clientUid}) {
      if (this.currContact.uid !== clientUid) return

      this.reset()
    },
    reset() {
      this.$store.dispatch({type: "mattersModule/resetNotes"})
      this.refreshId = +new Date()
    },
    handleBtnClick() {
      this.$frontageApi.send('matter_action', {action: 'add_note', origin: 'Notes tab fab'});
    },
    handleActions({action, noteUid, page}) {
      switch (action){
        case 'edit':
        this.$frontageApi.send('matter_action', {action: 'edit_note', noteUid, page, perPage: this.perPage, origin: 'Notes tab'});
        break;
      case 'clone':
        this.$track('Clone note');
        this.$frontageApi.send('matter_action', {action: 'clone_note', noteUid, origin: 'Notes tab'});
        break;
      case 'remove':
        const data = {title: this.$t('client.matters.matter_page.notes_tab.remove_note_dialog.title'), noteUid}
        this.$frontageApi.send('matter_action', {action: 'confirmation_dialog', data});
        break;
      }
    },
    async onRemoveEvent({noteUid}) {
      await this.$store.dispatch({type: "mattersModule/removeNote", payload: {id: noteUid}})
      this.$store.dispatch({type:'mattersModule/refreshMatterSummary'})
      this.reset()
      this.$frontageApi.send('matter_action', {action: 'note_removed', noteUid, origin: 'Notes tab'});
    }
  },
  destroyed() {
    this.$frontageApi.remove('fetch-notes', this.onRefreshEvent)
    this.$frontageApi.remove('remove-note', this.onRemoveEvent)
  }
}
</script>

<style scoped lang="scss">
.notes {
  position: relative;
  height: 100%;
  display: flex;

  .notes-wrapper {
    flex: 1;
    padding-bottom: 50px;
    overflow: auto;
  }
}

</style>
